/* eslint-disable no-unused-vars */
import { apolloClient } from "@/setup/apollo-setup";

import * as generic from "@/store/generic/mutations/result-status.js";
import { error } from '@/utils/notification';

import {
    GET_EXAM_LIST_BYFILTER
} from '@/queries/modules/examination/exam.js';

const state = {
  processing: false,
  error: null,
  success: null,
  exams: {}
};

const getters = {};

const mutations = {
  setError: generic.setError,
  setSuccess: (state, payload) => {
    state.error = null;
    state.success = payload;
    state.processing = false;
  },
  setProcessing: generic.setProcessing,
  setExamList: (state, { key, data }) => {
    state.exams[key] = data;
  },
  purgeExamination: (state) => {
    state.processing = false;
    state.error = null;
    state.success = null;
    state.exams = {};
  }
};

const actions = {

/**
  *  Action to Get Exam List By Filter
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *     @property {Object} payload : //TODO: Write comment
  *
  */

  async getExamListByFilter({ commit }, payload) {
    // commit('setProcessing', true);
    try {
      const fetch = await apolloClient
      .query({
        query: GET_EXAM_LIST_BYFILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      })
      const { data } = await fetch;
      // console.log(result);

      // TODO: Handle after success;
      const result = { status: { success: true, error: false, message: "" }, data: [ ...data.getExamsByFilter ] };

      if (result.status.success && result.data.length > 0) {
        commit("setExamList", { data: result.data, key: result.data[0].subject.id + "--" + result.data[0].teacher.id });
      }
      return;

    } catch (e) {
      commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }};
    }
  },


/**
  *  Action to Get Exam List By Filter
  *
  *   @param  {Object} context Vuex context object.
  *     @property {Vuex method (Function)} commit : "To commit a mutation"
  *     @property {Object} payload : //TODO: Write comment
  *
  */

  async getExamQuestionListByExamId({ commit }, payload) {
    // commit('setProcessing', true);
    try {
      const fetch = await apolloClient
      .query({
        query: GET_EXAM_LIST_BYFILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      })
      const { data } = await fetch;

      // TODO: Handle after success;
      const result = { status: { success: true, error: false, message: "" }, data: [ ...data.getExamsByFilter ] };

      if (result.status.success && result.data.length > 0) {
        commit("setExamList", { data: result.data, key: result.data[0].subject.id + "--" + result.data[0].teacher.id });
      }
      return;

    } catch (e) {
      commit('setError', error(e));
      return { status: { success: false, error: true, message: "", full: e }};
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
